
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Bell, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/providers/AuthProvider";

interface SidebarUserProfileProps {
  userName: string;
  userEmail?: string;
  avatarUrl?: string;
  notifications: number;
  userRole: string;
}

export function SidebarUserProfile({ 
  userName, 
  userEmail, 
  avatarUrl, 
  notifications, 
  userRole 
}: SidebarUserProfileProps) {
  const { logout } = useAuth();

  console.log("[SidebarUserProfile] Rendering with:", { userName, userRole });

  const handleSignOut = async () => {
    try {
      console.log("[SidebarUserProfile] Signing out user");
      await logout();
      toast.success("You have been signed out");
      // Note: Navigation is now handled in the AuthProvider
    } catch (error) {
      console.error("[SidebarUserProfile] Error signing out:", error);
      toast.error("Error signing out");
    }
  };
  
  return (
    <div className="mt-auto pt-4 border-t">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full overflow-hidden">
            <Avatar>
              <AvatarImage src={avatarUrl} />
              <AvatarFallback>{userName ? userName[0].toUpperCase() : 'U'}</AvatarFallback>
            </Avatar>
          </div>
          <div className="flex-1">
            <p className="font-medium truncate">{userName}</p>
            {userEmail && (
              <p className="text-xs text-muted-foreground truncate">{userEmail}</p>
            )}
          </div>
        </div>
        <div className="flex items-center">
          <Button 
            variant="ghost" 
            size="icon" 
            className="h-8 w-8 relative"
          >
            <Bell size={16} />
            {notifications > 0 && (
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-primary text-white text-xs flex items-center justify-center rounded-full">
                {notifications}
              </span>
            )}
          </Button>
        </div>
      </div>
      
      <Button 
        variant="outline" 
        className="w-full justify-start gap-2"
        onClick={handleSignOut}
      >
        <LogOut size={16} />
        Sign Out
      </Button>
    </div>
  );
}
